import { 
	Stacktrace as SentryStackTrace 
} from '@sentry/types';

export type Stacktrace = SentryStackTrace & { 
	target_frame?: number
}
